export const SITE_NAME = "Nohaya";
export const SITE_URL = "https://www.nohaya.com";
// Same-origin in production (CloudFront routes /api/* to the Lambda API).
// Falls back to the CloudFront domain directly for local builds.
export const API_BASE_URL =
  process.env.NEXT_PUBLIC_API_BASE_URL ?? "https://d319bntb2m01dq.cloudfront.net";
export const SITE_DESCRIPTION =
  "Nohaya is the all-in-one platform for AI tools, prompts, resume building, travel guides, and creator voice tools — everything you need, all in one place.";

// Not secrets (both ship to the client either way) -- hardcoded like
// SITE_URL above rather than env vars, so the PHP-served pages
// (php/site-shared/includes/chrome_head.php) can use the same literal
// values without needing their own env-loading story.
export const GA_MEASUREMENT_ID = "G-EPXPPG0VG3";
export const CLARITY_PROJECT_ID = "xehvv4qu01";

export type NavLink = {
  label: string;
  href: string;
};

export type NavGroup = {
  label: string;
  href: string;
  children?: NavLink[];
};

// Grouped by product cluster (Resume / AI / Travel) so the nav reads as
// topical sections rather than a flat list of unrelated pages.
export const NAV_GROUPS: NavGroup[] = [
  {
    label: "Resume",
    href: "/resumes",
    children: [
      { label: "Resume Builder", href: "/resume-builder" },
      { label: "Resume Examples", href: "/resumes" },
      { label: "ATS Checker", href: "/ats-checker" },
      { label: "Resume Templates", href: "/resume-templates" },
      { label: "Cover Letter Builder", href: "/cover-letter-builder" },
      { label: "Resume Writing Service", href: "/resume-services" },
    ],
  },
  {
    label: "AI",
    href: "/ai-tools",
    children: [
      { label: "AI Tools", href: "/ai-tools" },
      { label: "Prompt AI", href: "/prompts" },
      { label: "Voice AI", href: "/creators" },
      { label: "Email Cleaner", href: "/email-cleaner" },
    ],
  },
  {
    label: "Travel",
    href: "/places",
    children: [
      { label: "Places", href: "/places" },
      { label: "Local Guides", href: "/local-guides" },
      { label: "Trip Planner", href: "/trip-planner" },
    ],
  },
];

export const NAV_LINKS: NavLink[] = [
  { label: "All Apps", href: "/apps" },
  { label: "Blog", href: "/blog" },
  { label: "Pricing", href: "/pricing" },
];

export const FOOTER_LINKS: { heading: string; links: NavLink[] }[] = [
  {
    heading: "Product",
    links: [
      { label: "Apps", href: "/apps" },
      { label: "AI Tools", href: "/ai-tools" },
      { label: "Email Cleaner", href: "/email-cleaner" },
      { label: "Prompts", href: "/prompts" },
      { label: "Resumes", href: "/resumes" },
      { label: "Resume Builder", href: "/resume-builder" },
      { label: "Resume Templates", href: "/resume-templates" },
      { label: "ATS Checker", href: "/ats-checker" },
      { label: "Cover Letter Builder", href: "/cover-letter-builder" },
      { label: "Resume Writing Service", href: "/resume-services" },
      { label: "Pricing", href: "/pricing" },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "About Us", href: "/about" },
      { label: "Blog", href: "/blog" },
      { label: "Careers", href: "/careers" },
      { label: "Contact", href: "/contact" },
    ],
  },
  {
    heading: "Resources",
    links: [
      { label: "Documentation", href: "/docs" },
      { label: "Help Center", href: "/help" },
      { label: "Community", href: "/community" },
      { label: "Status", href: "/status" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Privacy Policy", href: "/privacy" },
      { label: "Terms of Service", href: "/terms" },
      { label: "Refund Policy", href: "/refund" },
      { label: "Cookies", href: "/cookies" },
    ],
  },
];
